<template>
    <div class="checkbox-input" >
        <table class="ci-table">
            <tr v-for="item in options" :key="item[value]">
                <td>
                    <span class="callname">{{ item[label] }}</span>
                </td>
                <td>
                    <el-input type="number" v-model="avgNum[item[value]]" :size="size" clearable></el-input>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: 'CheckboxInput',
    props: {
        options: {
            type: Array,
        },
        label: {
            type: String,
        },
        value: {
            type: String,
            default: 'id'
        },
        size: {
            type: String,
            default: 'mini'
        }
    },
    data() {
        return {
            avgNum: {},
        }
    }
}
</script>

<style scoped>
.checkbox-input .ci-con {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.checkbox-input .callname {
    color: #409EFF;
}

.checkbox-input td {
    padding: 0.1rem;
}

</style>


// WEBPACK FOOTER //
// src/commonReform/CheckboxInput.vue